import {HandlerOf} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {
  DropLinePositionsEnum,
  WorkspacePersonalWorkspaceDragItem,
} from '../../../../components/inboxes/workspaces/dnd/workspaceDragDropTypes';
import {VisualCustomView} from '../../../../helpers/models/customViewHelpers';
import {CustomViewModel} from '../../../../models/api/customViewModel';
import {DelegationModel} from '../../../../models/api/delegationModel';
import {InboxModel} from '../../../../models/api/inboxModel';
import {TagModel} from '../../../../models/api/tagModel';
import {TeammateModel} from '../../../../models/api/teammateModel';
import {TeamModel} from '../../../../models/api/teamModel';

export enum WorkspaceDropNestTagTargetRelationshipsEnum {
  PARENT = 'PARENT',
  SIBLING = 'SIBLING',
}

export interface WorkspaceDropNestTagArgs {
  childTagId: TagModel['id'];
  targetTagId: TagModel['id'] | undefined;
  targetRelationship: WorkspaceDropNestTagTargetRelationshipsEnum;
  // customView is only populated when the target relationship is parent.
  // When we change the parent, we need to access the tag objects in order to access the
  // parental relationship and avoid conflicting selection states in the parent tree.
  customView?: VisualCustomView;
}
export type WorkspaceTagDropNestHandler = HandlerOf<WorkspaceDropNestTagArgs>;

export interface WorkspaceDropReorderItemArgs<IdType> {
  droppedItemId: IdType;
  targetItemId: IdType;
  linePosition: DropLinePositionsEnum;
}

export type WorkspaceDropReorderTagArgs = WorkspaceDropReorderItemArgs<CustomViewModel['id']>;
export type WorkspaceDropReorderTagHandler = HandlerOf<WorkspaceDropReorderTagArgs>;

export type WorkspaceDropReorderUserInboxArgs = WorkspaceDropReorderItemArgs<InboxModel['id']>;
export type WorkspaceDropReorderUserInboxHandler = HandlerOf<WorkspaceDropReorderUserInboxArgs>;

export type WorkspaceDropReorderTeammateArgs = WorkspaceDropReorderItemArgs<TeammateModel['id']>;
export type WorkspaceDropReorderTeammateHandler = HandlerOf<WorkspaceDropReorderTeammateArgs>;

export type WorkspaceDropReorderDelegationArgs = WorkspaceDropReorderItemArgs<DelegationModel['id']>;

export interface WorkspaceDropReorderTeamInboxArgs extends WorkspaceDropReorderItemArgs<InboxModel['id']> {
  teamId: TeamModel['id'];
}
export type WorkspaceDropReorderTeamInboxHandler = HandlerOf<WorkspaceDropReorderTeamInboxArgs>;

export interface WorkspaceDropReorderTeamViewArgs
  extends WorkspaceDropReorderItemArgs<CustomViewModel['id']> {
  teamId: TeamModel['id'];
}
export type WorkspaceDropReorderTeamViewHandler = HandlerOf<WorkspaceDropReorderTeamViewArgs>;

export interface WorkspaceDropReorderTeammateWorkspaceItemArgs {
  droppedFolder: WorkspacePersonalWorkspaceDragItem;
  targetFolder: WorkspacePersonalWorkspaceDragItem;
  linePosition: DropLinePositionsEnum;
}
export type WorkspaceDropReorderTeammateWorkspaceItemHandler =
  HandlerOf<WorkspaceDropReorderTeammateWorkspaceItemArgs>;
